/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth } = borders;

export default {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      borderBottom:
        theme.palette.mode === "dark"
          ? `${borderWidth[1]} solid rgba(255, 255, 255, 0.12)` // Better contrast for dark mode
          : `${borderWidth[1]} solid ${theme.palette.grey[200]}`,
      color: theme.palette.text.primary, // Use theme text color
    }),
  },
};
